import { Grid } from '@mui/material'
import {
  GameProvidersComponent,
  GameCategoriesComponent,
  GamesComponent,
} from './'

export const CasinoComponent = () => {
  return (
    <Grid container spacing={2} marginTop={2}>
      <Grid item xs={6}>
        <GameCategoriesComponent />
      </Grid>
      <Grid item xs={6}>
        <GameProvidersComponent />
      </Grid>
      <Grid item xs={12}>
        <GamesComponent />
      </Grid>
    </Grid>
  )
}
